const loadJavascript = ({ constructorSuffix, host, signal }) =>
  new Promise((resolve, reject) => {
    const scriptId = `micro-frontend-script-${constructorSuffix}`

    if (document.getElementById(scriptId)) {
      resolve({ status: 'mounted' })
      return
    }

    if (window.mountCreateTimePollApp) {
      resolve({ status: 'fetched' })
      return
    }

    const config = {
      cache: 'no-store',
      signal: signal
    }
    fetch(`${host}/asset-manifest.json`, config)
      .then((res) => res.json())
      .then((manifest) => {
        const script = document.createElement('script')
        script.id = scriptId
        script.crossOrigin = ''
        script.src = `${host}/${manifest['main.js']}`
        script.onload = () => {
          if (window.mountCreateTimePollApp) {
            resolve({
              status: 'OK',
              mountAction: window.mountCreateTimePollApp
            })
          }
          resolve({ status: 'FAILED' })
        }
        document.body.appendChild(script)
      })
      .catch(reject)
  })

export const render = async ({
  host,
  containerId,
  constructorSuffix,
  signal
  // params
}) => {
  try {
    if (window.mountCreateTimePollApp === undefined) {
      const response = await loadJavascript({
        host,
        constructorSuffix,
        signal
      })
      if (response.status === 'OK') {
        response.mountAction(containerId)
        return
      }
    }
    return {
      ok: true
    }
  } catch (e) {
    console.log(e)
    throw new Error(`no defined microfront constructor`)
  }
}

export const unmount = ({ containerId }) => {
  /*  if (window[`microfrontUnmount${constructorSuffix}`] === undefined) {
    return
  }
  window[`microfrontUnmount${constructorSuffix}`](containerId)
 */
  if (window.unmountCreateTimePollApp === undefined) {
    return
  }
  window.unmountCreateTimePollApp(containerId)
}



// WEBPACK FOOTER //
// ./src/actions/microfrontend.js